module.exports = {
  Days: 'Ngày',
  Weeks: 'Tuần',
  Months: 'Tháng',
  CurrentlySelected: '(Lựa chọn hiện tại)',
  CurrentPage: '(Trang hiện tại)',
  NonTicketSettlement: 'Không kết phiếu',
  TicketSettlement: 'Kết phiếu',
  MonthlySettlement: 'Kết tháng',
  WeeklySettlement: 'Kết tuần',
  Monthly: 'Hàng tháng',
  Day: 'Ngày',
  CreditControl: 'Kiểm soát tín dụng',
  All: 'Tất cả',
  PleaseSelectAPartner: 'Vui lòng chọn đối tác.',
  InvoiceDate: 'Ngày hóa đơn',
  BusinessDate: 'Ngày nghiệp vụ',
  BillingDate: 'Ngày hóa đơn',
  CostFinancialDate: 'Ngày tài chính chi phí',
  System: 'Hệ thống',
  PleaseASpecialApprovalBusiness: 'Vui lòng chọn nghiệp vụ đặc biệt',
  SpecialApprovalSuccessful: 'Phê duyệt đặc biệt thành công',
  CancelledSpecialApprovalSuccessful: 'Hủy phê duyệt đặc biệt thành công',
  OceanShipping: 'Vận tải biển',
  PleaseFillInTheContact: 'Vui lòng điền thông tin liên hệ!',
  Other: 'Khác',
  CustomerType: 'Loại khách hàng',
  CustomerContactChannel: 'Kênh tiếp xúc khách hàng',
  DueBePrintedOrNeeded: 'Do vượt quá kiểm soát tín dụng, phiếu này đã bị khóa, không thể in hoặc EDI. Vui lòng liên hệ cấp trên để mở khóa khi cần!',
  DearCustomersAssociatedWith: 'Bạn chỉ có thể chọn khách hàng liên quan đến bán hàng thôi (⊙o⊙) nhé',
  CharacterTooLongPleaseAgain: 'Độ dài ký tự vượt quá, vui lòng bảo trì lại!',
  ShippingTypeCannotBeEmpty: 'Loại vận chuyển không được để trống',
  FullhalfJourneyCannotBeEmpty: 'Toàn trình/bán trình không được để trống',
  RouteCannotBeEmpty: 'Tuyến đường không được để trống',
  PleaseAPieceOfData: 'Vui lòng chọn một dữ liệu!',
  OverdueFees: 'Chi phí quá hạn',
  OverControllAccountReceivable: 'Đối tượng thanh toán vượt tín dụng (Phải thu)',
  Family: 'Nhà',
  CRMExpiredTip: 'Kính gửi quý khách, module CRM bạn đã mua đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, có thể liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.<br><div style="margin-top: 5px;">Module CRM sẽ bị hạn chế truy cập, dữ liệu sẽ được lưu giữ. Sau khi gia hạn, có thể sử dụng lại.</div>',
  Barge: 'Sà lan',
  SalesInquiryListPage: 'Trang danh sách tra cứu bán hàng',
  RemoteBookingListPage: 'Trang danh sách đặt chỗ từ xa'
}
